export class contactAlert{
    AlertTypeId: number=0;
    Description: string
}
